import { render, staticRenderFns } from "./MoreMenuUser.vue?vue&type=template&id=96f2b562&scoped=true&"
import script from "./MoreMenuUser.vue?vue&type=script&lang=ts&"
export * from "./MoreMenuUser.vue?vue&type=script&lang=ts&"
import style0 from "./MoreMenuUser.vue?vue&type=style&index=0&id=96f2b562&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f2b562",
  null
  
)

export default component.exports